import axios from 'axios'

// CRITICAL: Define TOKEN_KEY here or import it
const TOKEN_KEY = "lumina_jwt"

// TODO: Replace with your actual backend URL when ready
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api'

const api = axios.create({
    baseURL: API_BASE_URL,
    timeout: 60000,
    headers: { 'Content-Type': 'application/json' },
})

// Request interceptor - attach JWT token to every request
api.interceptors.request.use((req) => {
    const jwt = localStorage.getItem(TOKEN_KEY)

    // Debug log
    console.log('Axios interceptor - Token:', jwt ? 'EXISTS' : 'MISSING')

    if (jwt && jwt !== "null" && jwt !== "undefined") {
        req.headers.Authorization = `Bearer ${jwt}`
        console.log('Axios interceptor - Added Authorization header')
    } else {
        delete req.headers.Authorization
        console.log('Axios interceptor - No token, skipping Authorization header')
    }

    return req
}, (error) => {
    console.error('Axios request interceptor error:', error)
    return Promise.reject(error)
})

// Response interceptor - handle 401 errors (unauthorized)
api.interceptors.response.use(
    (res) => res,
    (err) => {
        console.error('Axios response error:', err.response?.status, err.response?.data)

        if (err?.response?.status === 401) {
            localStorage.removeItem(TOKEN_KEY)
            if (window.location.pathname !== '/login' && window.location.pathname !== '/register') {
                window.location.replace('/login')
            }
        }
        return Promise.reject(err)
    }
)

export default api